__turbopack_context__.v({
  "accordion": "Accordion-module-scss-module__qqYyAq__accordion",
  "accordionInner": "Accordion-module-scss-module__qqYyAq__accordionInner",
  "accordionToggle": "Accordion-module-scss-module__qqYyAq__accordionToggle",
  "close": "Accordion-module-scss-module__qqYyAq__close",
  "enter": "Accordion-module-scss-module__qqYyAq__enter",
  "exit": "Accordion-module-scss-module__qqYyAq__exit",
  "fade-in": "Accordion-module-scss-module__qqYyAq__fade-in",
  "idle": "Accordion-module-scss-module__qqYyAq__idle",
  "isClickable": "Accordion-module-scss-module__qqYyAq__isClickable",
  "label": "Accordion-module-scss-module__qqYyAq__label",
  "open": "Accordion-module-scss-module__qqYyAq__open",
  "pagination": "Accordion-module-scss-module__qqYyAq__pagination",
  "panel": "Accordion-module-scss-module__qqYyAq__panel",
  "panelContent": "Accordion-module-scss-module__qqYyAq__panelContent",
  "panelInner": "Accordion-module-scss-module__qqYyAq__panelInner",
  "previous": "Accordion-module-scss-module__qqYyAq__previous",
  "upcoming": "Accordion-module-scss-module__qqYyAq__upcoming",
});
